/**
 * @generated SignedSource<<dc4d9e26268921fd6252d9793de1e3d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StatusBarContractCancelation_contract$data = {
  readonly cancelationScheduledFor: string | null;
  readonly " $fragmentType": "StatusBarContractCancelation_contract";
};
export type StatusBarContractCancelation_contract$key = {
  readonly " $data"?: StatusBarContractCancelation_contract$data;
  readonly " $fragmentSpreads": FragmentRefs<"StatusBarContractCancelation_contract">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StatusBarContractCancelation_contract",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cancelationScheduledFor",
      "storageKey": null
    }
  ],
  "type": "Contract",
  "abstractKey": null
};

(node as any).hash = "64a02f16edaf6db27f8fab12fa5ed2b4";

export default node;
